// import AllMutualFundsSvg from '../../../assets/icons/all-mutual-funds.svg';
import AllMutualFundsSvg from '../../../assets/icons/top-performance-icon.svg';
import InvestmentIdeasSvg from '../../../assets/icons/investment-ideas.svg';
import StartASipSvg from '../../../assets/icons/start-a-sip.svg';
import SaveTaxSvg from '../../../assets/icons/save-tax.svg';

export const getIconForFundCard = (iconName) => {
  switch (iconName) {
    case 'AllMutualFundsIcon':
      return <AllMutualFundsSvg id='mf_cards_All_Mutual_Funds'/>;
    case 'InvestmentIdeasIcon':
      return <InvestmentIdeasSvg id='mf_cards_Investment_Ideas'/>;
    case 'StartASipIcon':
      return <StartASipSvg id='mf_cards_Plan_Goals_With_SIP'/>;
    case 'SaveTaxIcon':
      return <SaveTaxSvg id='mf_cards_Save_Tax'/>;
    default:
      return <AllMutualFundsSvg id='mf_cards_All_Mutual_Funds'/>;
  }
};
